export default __webpack_public_path__ + "static/media/chat_bot_image13.d68bf9b5.jpg";